/**
 * HUB-E — Bandeau accès pages stock legacy + liens profonds.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Package, ArrowRight } from 'lucide-react';

const LINKS = [
  { to: '/stock', label: 'Stock', testId: 'activite-stock-link-stock' },
  { to: '/stock/mouvements', label: 'Mouvements', testId: 'activite-stock-link-mouvements' },
  { to: '/stock/historique', label: 'Historique stock', testId: 'activite-stock-link-historique' },
];

export default function ActiviteStockAccessBanner() {
  return (
    <div
      className="rounded-xl border p-4 space-y-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid="activite-stock-access-banner"
    >
      <div className="flex items-start gap-3">
        <div
          className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center border"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-elevated)' }}
        >
          <Package className="w-5 h-5 text-[var(--rm-gray-200)]" />
        </div>
        <div>
          <p className="text-sm font-semibold text-[var(--rm-white)]">Pages stock complètes</p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5">
            Le Centre Activité complète les outils existants — gestion inchangée sur /stock.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center gap-2"
            data-testid={link.testId}
          >
            {link.label}
            <ArrowRight className="w-4 h-4" />
          </Link>
        ))}
      </div>
    </div>
  );
}
